import { z } from 'zod';
import { getMutationSchema } from '../../../../ui/util/getMutationSchema';
import { ResourceType } from '../../../enumerations/ResourceType';
import { useIndirectlyVersionedResourceAdapter } from '../../../resource-base/adapters/useIndirectlyVersionedResourceAdapter';
import { useMultiResourceSingleParentedResourceAdapterActions } from '../../../resource-base/adapters/useMultiResourceSingleParentedResourceAdapterActions';
import {
    defaultIndirectlyVersionedAndNamedArtifactResource,
    IndirectlyVersionedAndNamedArtifactResourceSchema,
} from '../../../resource-base/artifactResourceTypes';

export enum ProcessAreaRoleRelationPropertyValidation {
    NAME = 'NAME',
    DESCRIPTION = 'DESCRIPTION',
}

export const ProcessAreaRoleRelationResourceSchema = IndirectlyVersionedAndNamedArtifactResourceSchema.extend({
    resourceType: z.literal(ResourceType.PROCESS_AREA_ROLE_RELATION).default(ResourceType.PROCESS_AREA_ROLE_RELATION),
    description: z.string(),
});
export const ProcessAreaRoleRelationMutationResourceSchema = getMutationSchema(ProcessAreaRoleRelationResourceSchema);

export type ProcessAreaRoleRelationResource = z.infer<typeof ProcessAreaRoleRelationResourceSchema>;

export const defaultProcessAreaRoleRelationResource: ProcessAreaRoleRelationResource = {
    ...defaultIndirectlyVersionedAndNamedArtifactResource,
    resourceType: ResourceType.PROCESS_AREA_ROLE_RELATION,
    description: '',
};

export function useProcessAreaRoleRelationActions() {
    return {
        ...useMultiResourceSingleParentedResourceAdapterActions(
            'project/process-area-role-relation',
            ResourceType.PROCESS_AREA_ROLE_RELATION,
            ProcessAreaRoleRelationResourceSchema
        ),
        ...useIndirectlyVersionedResourceAdapter(
            'project/process-area-role-relation',
            ResourceType.PROCESS_AREA_ROLE_RELATION,
            ProcessAreaRoleRelationResourceSchema
        ),
    };
}
